




























































































import { Component, Mixins } from 'vue-property-decorator';

import { ListingFilter, ListingOrderBy, ProfileFilter, TestimonialFilter, TestimonialOrderBy } from 'client-website-ts-library/filters';
import {
  ListingStatus,
  ListingCategory,
  Profile,
  WebsiteLevel,
  WebsiteProfileDisplayType,
} from 'client-website-ts-library/types';

import { View } from 'client-website-ts-library/plugins';
import { API, Config } from 'client-website-ts-library/services';

import { EmbeddedContent, EmbeddedContentType } from 'client-website-ts-library/types/EmbeddedContent/EmbeddedContent';
import TestimonialCycler from '@/components/Testimonials/TestimonialCycler.vue';
import Listings from '../components/Listings.vue';
import SideBySide from '../components/Layout/SideBySide.vue';
import ItemCycler from '../components/Cycler/ItemCycler.vue';
import AgentCardCycler from '../components/Cycler/AgentCardCycler.vue';
import WelcomeModal from '../components/WelcomeModal.vue';
import Embeddable from '../components/Common/Embeddable.vue';
import ListingSearch from '../components/ListingSearch.vue';
import Awards from '../components/Awards.vue';

import { ItemCyclerSlide, ItemCyclerImageSlide } from '../app_code/ItemCycler';

@Component({
  components: {
    Listings,
    SideBySide,
    ItemCycler,
    WelcomeModal,
    Embeddable,
    ListingSearch,
    Awards,
    AgentCardCycler,
    TestimonialCycler,
  },
})
export default class Home extends Mixins(View) {
  private hasRentalListings = false;

  private listingFilterSales = new ListingFilter({
    Statuses: [
      ListingStatus.Current,
      ListingStatus.UnderContract,
    ],
    Categories: [
      ListingCategory.ResidentialSale,
      ListingCategory.ResidentialLand,
      ListingCategory.Rural,
    ],
    PageSize: 3,
    OrderByStatements: [
      ListingOrderBy.CreateDateDesc,
    ],
  });

  private listingFilterRentals = new ListingFilter({
    Statuses: [
      ListingStatus.Current,
    ],
    Categories: [
      ListingCategory.ResidentialRental,
    ],
    PageSize: 3,
    OrderByStatements: [
      ListingOrderBy.CreateDateDesc,
    ],
  });

  private testimonialFilter: TestimonialFilter | null = null;

  private cyclerImages: ItemCyclerSlide[] = [
    new ItemCyclerImageSlide({ source: '/assets/images/home/slider/1', formats: ['webp', 'avif', 'jpg'], fallback: 'jpg' }),
    new ItemCyclerImageSlide({ source: '/assets/images/home/slider/2', formats: ['webp', 'avif', 'jpg'], fallback: 'jpg' }),
    new ItemCyclerImageSlide({ source: '/assets/images/home/slider/3', formats: ['webp', 'avif', 'jpg'], fallback: 'jpg' }),
    new ItemCyclerImageSlide({ source: '/assets/images/home/slider/4', formats: ['webp', 'avif', 'jpg'], fallback: 'jpg' }),
    new ItemCyclerImageSlide({ source: '/assets/images/home/slider/5', formats: ['webp', 'avif', 'jpg'], fallback: 'jpg' }),
    new ItemCyclerImageSlide({ source: '/assets/images/home/slider/6', formats: ['webp', 'avif', 'jpg'], fallback: 'jpg' }),
    new ItemCyclerImageSlide({ source: '/assets/images/home/slider/7', formats: ['webp', 'avif', 'jpg'], fallback: 'jpg' }),
    new ItemCyclerImageSlide({ source: '/assets/images/home/slider/8', formats: ['webp', 'avif', 'jpg'], fallback: 'jpg' }),
    new ItemCyclerImageSlide({ source: '/assets/images/home/slider/9', formats: ['webp', 'avif', 'jpg'], fallback: 'jpg' }),
    new ItemCyclerImageSlide({ source: '/assets/images/home/slider/10', formats: ['webp', 'avif', 'jpg'], fallback: 'jpg' }),
    new ItemCyclerImageSlide({ source: '/assets/images/home/slider/11', formats: ['webp', 'avif', 'jpg'], fallback: 'jpg' }),
    new ItemCyclerImageSlide({ source: '/assets/images/home/slider/12', formats: ['webp', 'avif', 'jpg'], fallback: 'jpg' }),
    new ItemCyclerImageSlide({ source: '/assets/images/home/slider/13', formats: ['webp', 'avif', 'jpg'], fallback: 'jpg' }),
    new ItemCyclerImageSlide({ source: '/assets/images/home/slider/14', formats: ['webp', 'avif', 'jpg'], fallback: 'jpg' }),
  ];

  private profiles: Profile[] = [];

  mounted() {
    API.Profiles.Search(new ProfileFilter({
      SearchLevel: WebsiteLevel.Franchise,
      SearchGuid: Config.Website.Settings!.WebsiteId,
    }), true).then((profiles) => {
      this.profiles = profiles.filter((p) => p.DisplayType === WebsiteProfileDisplayType.Agent);
    });

    this.testimonialFilter = new TestimonialFilter({
      SearchLevel: WebsiteLevel.Office,
      SearchGuid: Config.Website.Settings!.WebsiteId,
      OrderByStatements: [TestimonialOrderBy.CreateDateDesc],
    });
  }

  /*
  private eb: EmbeddedContent = {
    Type: EmbeddedContentType.Youtube,
    EmbedId: '',
  };
  */
}
